import { Typography } from "@material-ui/core"
import useRedirectIfPreviousComponentsAreNotSelected from "common/useRedirectIfPreviousComponentsAreNotSelected"
import { useAppDispatch, useTypedSelector } from "store"
import styled from "styled-components"
import Accessory from "./Accessory"
import { setSelectedAccessories } from "./accessoriesSlice"

const StyledAccessories = styled.ul`
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  margin-right: -7px;
  margin-left: -7px;
  padding: 0;

  ${(p) => p.theme.breakpoints.up("md")} {
    padding-bottom: ${(p) => p.theme.spacing(2)}px;
  }

  li {
    width: 50%;
    padding: 7px;
    display: flex;
  }
`

const AccessoriesSidebar = () => {
  const { accessories, selectedAccessoriesCodes } = useTypedSelector(
    (state) => state.accessories
  )

  const dispatch = useAppDispatch()

  useRedirectIfPreviousComponentsAreNotSelected()

  return (
    <>
      <Typography variant="srOnly" component={"h1"}>
        אביזרים
      </Typography>
      <StyledAccessories>
        {accessories.map((accessory) => {
          const { code } = accessory.details

          const isSelected = selectedAccessoriesCodes.includes(code)

          return (
            <li key={code} role="presentation">
              <Accessory
                accessory={accessory}
                isSelected={isSelected}
                onSelect={() =>
                  dispatch(
                    setSelectedAccessories(
                      isSelected
                        ? selectedAccessoriesCodes.filter((c) => c !== code)
                        : selectedAccessoriesCodes.concat(code)
                    )
                  )
                }
              />
            </li>
          )
        })}
      </StyledAccessories>
    </>
  )
}

export default AccessoriesSidebar
